import _isEmpty from 'lodash/isEmpty'

/**
 * It watches the getInputValue if available
 */
export default {
  data () {
    return {
      inputError: false
    }
  },

  methods: {
    getInputContainer () {
      if (this.$parent.isInputContainer) return this.$parent
      return null
    },

    runInputValidator (newVal) {
      for (let node of this.$children) {
        if (node.isBaseInput) {
          let rtr = node.validateInput(newVal, this.getConstraints, this)
          this.inputError = rtr

          // If not input error than it is valid
          let ic = this.getInputContainer()
          if (ic) {
            ic.updateValidity(this.inputName, !this.inputError)
          }
        }
      }
    }
  },

  computed: {
    getInputError () {
      return this.inputError
    },

    hasConstraints () {
      return !_isEmpty(this.constraints)
    }
  },

  mounted () {
    // If initial input test should be made
    if (this.getConstraints.onInit) {
      this.runInputValidator(this.getInputValue)
    }
  },

  props: {
    constraints: {
      type: Object,
      required: false,
      default: () => { return {} }
    }
  },
  watch: {
    getInputValue: {
      handler: function (newVal) {
        this.runInputValidator(newVal)
      },
      deep: true
    },

    constraints: {
      handler: function (newVal) {
        // If initial input test should be made
        if (this.getConstraints.onInit) {
          this.runInputValidator(this.getInputValue)
        }
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/standard/input/inputValidator.js